import { useEffect, useState } from 'react';

import Image from 'react-bootstrap/Image';

import Menu from '../../components/MenuOvoCaipira';

import header from '../../images/ovo-caipira-header.png'

import constantes from '../../helpers/constanteHelper';

function Sobre() {
    const [width, setWidth] = useState(window.innerWidth);


    function observarMudancaWidth() {
        setWidth(window.innerWidth);
    }

    useEffect(() => {
        window.addEventListener('resize', observarMudancaWidth);

        // Scroll para o topo da página para melhor visualização no mobile ou em resoluções menores
        window.scrollTo({ top: 0, left: 0, behavior: 'smooth' })

        return () => {
            window.removeEventListener('resize', observarMudancaWidth);
        }
    }, []);

    const resolucaoMobile = width <= constantes.RESPONSIVIDADE.LARGURA_MOBILE;

    return (
        <>
            <div style={{ minHeight: '100vh', background: constantes.CORES.MARROM_OVO_CAIPIRA }} className='text-center d-flex flex-column align-items-center'>
                <Menu opcaoSelecionada={'sobre'} />
                <div className='animate__animated animate__fadeIn d-flex flex-column align-items-center'>
                    <div style={{ height: resolucaoMobile ? '20px' : '80px' }}></div>

                    <Image style={{ height: '600px', objectFit: 'contain', padding: '20px' }} src={header} alt='logo' fluid />
                    <h1 className={resolucaoMobile ? 'mb-5' : 'mt-5 mb-5'} style={{ color: constantes.CORES.BRANCO_PADRAO, fontWeight: 700 }}>Certificação Ovo Caipira</h1>

                    <span className='mb-5' style={{ width: resolucaoMobile ? '90vw' : '70vw', color: constantes.CORES.BRANCO_PADRAO, fontSize: '20px', whiteSpace: 'pre-line', textAlign: resolucaoMobile ? 'justify' : 'center' }}>
                        O protocolo elaborado pela FairFood Certificações teve por base a Norma da ABNT 16437, transcrito de forma aplicável para cada granja.<br /><br />
                        Como oportunidade de se destacar no mercado, a certificação de ovos caipira vai lhe ajudar na elaboração de estratégias comerciais e marketing, diferenciando-o de outras marcas.<br /><br />
                    </span>

                </div>
            </div>
        </>
    );
}

export default Sobre;
